var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    fill: "#000000",
    stroke: "#000000",
    width: "200px",
    height: "200px",
    viewBox: "144 144 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IconSvg_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "IconSvg_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "IconSvg_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m596.48 535.68h-61.316l4.082-56.879c11.668-1.2422 21.016-10.664 21.727-22.562l15.305-213.05v-40.027c0-2.7812-2.2539-5.0391-5.0391-5.0391h-126.63c-2.7852 0-5.0391 2.2539-5.0391 5.0391l0.015626 40.387 15.285 212.66c0.73047 11.938 10.07 21.352 21.727 22.594l4.0859 56.879h-75.297c5.5547-5.8242 8.9922-13.688 8.9922-22.355v-209.51c0-17.883-14.547-32.43-32.43-32.43h-10.156l0.003906-67.867c0-2.7812-2.2539-5.0391-5.0391-5.0391l-95.422 0.003906c-2.7852 0-5.0391 2.2539-5.0391 5.0391v67.863h-10.148c-17.883 0-32.434 14.547-32.434 32.43v209.52c0 8.6641 3.4375 16.531 8.9961 22.355l-29.199-0.003907c-2.7852 0-5.0391 2.2539-5.0391 5.0391l0.003906 55.77c0 2.7812 2.2539 5.0391 5.0391 5.0391h392.97c2.7852 0 5.0391-2.2539 5.0391-5.0391l-0.003906-55.77c0-2.7852-2.2539-5.0391-5.0391-5.0391zm-105.73-0.36328-4.043-56.27h42.422l-4.0391 56.27zm75.449-327.12 0.011719 31.684h-116.57v-31.684zm-101.28 247.38c0-0.023437 0-0.042968-0.003907-0.0625l-14.789-205.56h115.57l-14.785 205.62c-0.45312 7.5117-6.6992 13.398-14.23 13.398h-57.543c-7.5273 0-13.773-5.8867-14.223-13.398zm-231.14-118.22h170.51v138.1h-170.51zm127.93-128.8v22.188h-19.809c-1.6289 0-3.1523 0.78516-4.0977 2.1094-4.3477 6.0898-11.367 9.7227-18.766 9.7227-7.4062 0-14.422-3.6367-18.77-9.7227-0.94531-1.3242-2.4688-2.1094-4.0977-2.1094h-19.809v-22.188zm-85.348 32.262h17.348c6.2812 7.457 15.566 11.836 25.328 11.836s19.039-4.3789 25.324-11.836h17.348v30.562l-85.348 0.003906zm-20.227 40.641h125.8c12.324 0 22.352 10.027 22.352 22.355v23.469h-170.52v-23.469c0-12.328 10.027-22.355 22.359-22.355zm-22.359 231.87v-27.793h170.51v27.793c0 12.328-10.027 22.355-22.352 22.355h-125.8c-12.332 0-22.359-10.027-22.359-22.355zm357.66 78.125h-382.89v-45.695h382.89z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExp);
export default __webpack_public_path__ + "static/media/exp.9e7fd62686cc4da0e3033ecdd7ae710b.svg";
export { ForwardRef as ReactComponent };